import { Component, OnInit } from '@angular/core';
import { MpButtonComponent } from '../../ui-components/mp-button/mp-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { MpSnackbarService } from '../../ui-components/mp-snackbar/mp-snackbar.service';
import { DatePipe, NgIf } from '@angular/common';
import { MpTooltipDirective } from '../../ui-components/mp-tooltip/mp-tooltip.directive';
import { MpInputComponent } from '../../ui-components/mp-input/mp-input.component';
import { FormControl } from '@angular/forms';
import { MpContextualMenuDirective } from '../../ui-components/mp-contextual-menu/mp-contextual-menu.directive';
import { MpSelectComponent } from '../../ui-components/mp-select/mp-select.component';
import { MpDatePickerComponent } from '../../ui-components/mp-date-picker/mp-date-picker.component';
import { MpCheckboxComponent } from '../../ui-components/mp-checkbox/mp-checkbox.component';
import { MpModalDirective } from '../../ui-components/mp-modal/mp-modal.directive';
import { MpTextareaComponent } from '../../ui-components/mp-textarea/mp-textarea.component';
import { MpHourPickerComponent } from '../../ui-components/mp-hour-picker/mp-hour-picker.component';
import { MpAutocompleteComponent } from '../../ui-components/mp-autocomplete/mp-autocomplete.component';
import { map, Observable } from 'rxjs';
import { AppointmentsService } from '../../services/appointments.service';
import { Appointment } from '../../models/appointment.model';
import { FixedDate, IntervalDate } from '../../models/date.model';
import { GeneralFilters } from '../../models/filter.model';
import { Pagination } from '../../widgets/lazy-loading/pagination.model';
import { IntervalTime } from '../../models/time.model';
import { SnackBarLevel, SnackBarLink } from '../../ui-components/mp-snackbar/mp-snackbar.model';

@Component({
  selector: 'app-showcase',
  templateUrl: './showcase.component.html',
  imports: [
    MpButtonComponent,
    TranslateModule,
    NgIf,
    MpTooltipDirective,
    MpInputComponent,
    MpSelectComponent,
    MpContextualMenuDirective,
    MpDatePickerComponent,
    DatePipe,
    MpCheckboxComponent,
    MpModalDirective,
    MpTextareaComponent,
    MpHourPickerComponent,
    MpAutocompleteComponent
  ],
  styleUrl: './showcase.component.scss'
})
export class ShowcaseComponent implements OnInit {

  public mpDatePickerOpened = false;
  public mpHourPickerOpened = false;
  public mpCheckboxOpened = false;
  public mpButtonOpened = false;
  public mpSnackbarOpened = true;
  public mpTooltipOpened = false;
  public mpInputOpened = false;
  public mpTextareaOpened = false;
  public mpContextualMenuOpened = false;
  public mpModalOpened = false;
  public mpSelectOpened = false;
  public mpAutocompleteOpened = false;
  public mpSelectAutocompleteOpened = false;
  public isLoading = false;

  public inputStringFormControl = new FormControl<string>('', []);
  public inputValueChangeFormControl = new FormControl<string>('Chaussettes', []);
  public inputNumberValue: number = 42;
  public textareaFormControl = new FormControl<string>('', []);
  public textareaValue: string = '──────▄▀▄─────▄▀▄\n─────▄█░░▀▀▀▀▀░░█▄\n─▄▄──█░░░░░░░░░░░█──▄▄\n█▄▄█─█░░▀░░┬░░▀░░█─█▄▄█';
  public inputWithIconValue: string = '<(o_o)>';
  public autocompleteFormControl = new FormControl<string>('', []);
  public autocompleteValue: string = 'Test du readonly';
  public selectValueMultiple: string[] = [];
  public selectMultipleObject: { name?: string, id?: number }[] = [{ name: 'Chocolat', id: 1 }];
  public selectAsyncMultipleObject: Appointment;
  public selectValueString: string;
  public autoCompleteValueString: string;
  public autoCompleteMultiple: string;
  public autoCompleteMultipleObject: string;
  public selectFormControl = new FormControl<{ name: string }>({ name: 'ça' }, []);
  public datePickerValue = new FixedDate();
  public datePickerFormControl = new FormControl<string>(undefined, []);
  public hoursDatePickerFormControl = new FormControl<IntervalTime>(undefined, []);
  public datePickerWithIntervalFormControl = new FormControl<IntervalDate>(undefined, []);
  public datePickerEverythingFormControl = new FormControl<IntervalDate>(undefined, []);
  public hoursDatePickerEverythingFormControl = new FormControl<IntervalTime>(undefined, []);
  public datePickerWithHoursFormControl = new FormControl<Date>(undefined, []);
  public hourPickerValue: string = '12:10';
  public hourPickerFormControl = new FormControl<string>(undefined, []);
  public checkBoxValue: boolean;
  public selectAutocompleteOptions: string[] = ['Blanc', 'Jaune', 'Vert', 'Bleu', 'Violet', 'Rouge', 'Orange', 'Noir'];
  public selectAutocompleteMultipleObjectOptions: { id: number, name: string }[] = [
    { id: 1, name: 'Blanc' },
    { id: 2, name: 'Jaune' },
    { id: 3, name: 'Vert' },
    { id: 4, name: 'Bleu' },
    { id: 5, name: 'Violet' },
    { id: 6, name: 'Rouge' },
    { id: 7, name: 'Orange' },
    { id: 8, name: 'Noir' }
  ];
  public selectAutocompleteOptionsShown: string[] = [...this.selectAutocompleteOptions];
  public selectAutocompleteMultipleOptionsShown: string[] = [...this.selectAutocompleteOptions];
  public selectAutocompleteMultipleObjectOptionsShown: {
    id: number,
    name: string
  }[] = [...this.selectAutocompleteMultipleObjectOptions];
  public autocompleteOptions = ['Sibérien', 'Maine coon', 'Norvégien', 'Angora turc', 'Sacré de Birmanie'];
  public selectAsyncOptions: Appointment[] = [];

  constructor(private snackbarService: MpSnackbarService, private appointmentsService: AppointmentsService) {}

  ngOnInit() {
    this.asyncSelectDataFetch(0, 10, '').subscribe((response) => {
      this.selectAsyncOptions = response.content;
    });
  }

  public getAppointmentOptionLabel(option: Appointment) {
    return option.id;
  }

  public getObjectOptionLabel(option: { id?: number, name: string }) {
    return option.name;
  }

  public isSameAutocompleteOption(option1: { id: number, name: string }, option2: { id: number, name: string }) {
    return option1.id === option2.id;
  }

  public asyncSelectDataFetch(page: number = 0, pageSize: number = 10, search: string = '') {
    return this.appointmentsService.get({}, { page: page, size: pageSize }, [{
      field: GeneralFilters.SEARCH,
      value: search
    }]).pipe(
      map((response: Pagination<Appointment>) => {
        return { content: response.items, totalPages: response.totalPages };
      })
    ) as Observable<{ content: Appointment[], totalPages: number }>;
  }

  public autocompleteChanged(value: string) {
    if (value) {
      return [...this.autocompleteOptions.filter((option: string) => {
        return option.toLowerCase().startsWith(value.toLowerCase());
      })];
    } else {
      return [...this.autocompleteOptions];
    }
  }

  public selectAutocompleteChanged(value: string) {
    if (value) {
      this.selectAutocompleteOptionsShown = this.selectAutocompleteOptions.filter((option: string) => {
        return option.startsWith(value);
      });
    } else {
      this.selectAutocompleteOptionsShown = [...this.selectAutocompleteOptions];
    }
  }

  public selectAutocompleteMultipleChanged(value: string) {
    if (value) {
      this.selectAutocompleteMultipleOptionsShown = this.selectAutocompleteOptions.filter((option: string) => {
        return option.startsWith(value);
      });
    } else {
      this.selectAutocompleteMultipleOptionsShown = [...this.selectAutocompleteOptions];
    }
  }

  public selectAutocompleteMultipleOptionsChanged(value: string) {
    if (value) {
      this.selectAutocompleteMultipleObjectOptionsShown = this.selectAutocompleteMultipleObjectOptions.filter(
        (option: { id: number, name: string }) => {
          return option.name.startsWith(value);
        }
      );
    } else {
      this.selectAutocompleteMultipleObjectOptionsShown = [...this.selectAutocompleteMultipleObjectOptions];
    }
  }

  public openSnackBarInfo(text?: string, messageVariables?: { [key: string]: string }) {
    this.snackbarService.openSnackBarInfo(text || 'SHOWCASE.SNACKBAR.TITLE','SHOWCASE.SNACKBAR.DESCRIPTION', messageVariables);
  }

  public openSnackBarInfoWithLink() {
    this.snackbarService.openSnackBar({
      title: 'SHOWCASE.SNACKBAR.TITLE',
      description: 'SHOWCASE.SNACKBAR.DESCRIPTION',
      level: SnackBarLevel.Info,
      link: { label: 'Un lien', url: '/private/freight-forwarding/follow-up' }
    });
  }

  public openSnackBarWarning() {
    this.snackbarService.openSnackBarWarning('SHOWCASE.SNACKBAR.TITLE', 'SHOWCASE.SNACKBAR.DESCRIPTION');
  }

  public openSnackBarError() {
    this.snackbarService.openSnackBarError('SHOWCASE.SNACKBAR.TITLE', 'SHOWCASE.SNACKBAR.DESCRIPTION');
  }

  public openSnackBarSuccess() {
    this.snackbarService.openSnackBarSuccess('SHOWCASE.SNACKBAR.TITLE', 'SHOWCASE.SNACKBAR.DESCRIPTION');
  }

  public inputIconClicked() {
    this.snackbarService.openSnackBarInfo('Bouton cliqué !');
  }

}
